import { Component, OnInit, ViewChild,HostListener, ElementRef,Renderer2} from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Getunitdetails, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Base64Pipe } from '../../../services/pipes/base64/base64.pipe';
import { Options, LabelType } from '@angular-slider/ngx-slider';
import Swal from 'sweetalert2';

declare var document, $;


@Component({
  selector: 'app-order-management',
  templateUrl: './order-management.component.html',
  styleUrls: ['./order-management.component.css']
})
export class OrderManagementComponent implements OnInit {
  @ViewChild('myPond') myPond: any
  @ViewChild('Writer_Pond_Attach') Writer_Pond_Attach: any
  @ViewChild('Writer_Pond_Plag') Writer_Pond_Plag: any


  public writersRegion            : any = AppSettings.writersRegion;
  public orderStatus              : any = AppSettings.orderStatus;
  public validInvalidSales        : any = AppSettings.validInvalidSales;
  public loading                  : any = false;
  public paginatePage             : any;
  public leads                    : any = [];
  public leads_Copy               : any = [];
  public checkedClass             : any = false;
  public agents                   : any;
  public select2Agents            : any = [];
  public qaComments               : any = [];
  public agentsSub                : any;
  public qa                       : any;
  public writers                  : any;
  public activeUser               : any = false;
  public verifiedLoader           : any = false;
  public verifiedStatusOrderId    : any = false;
  public markVerifiedStatus       : any = false;

  public showprice                : any;
  public notesInfo                : any;
  public menuBtnClick             : any = false;

  public verifiedStatusesForFilter: any = [
    {name: 'Auto Slaes',value: "auto"},
    {name: 'Verified',value: 1},
    {
      name: 'Un-verified',
      value: '0'
    }
  ];

  public verifiedStatuses: any = [
    {
      name: 'Verified',
      value: 1,
    },
    {
      name: 'Un-verified',
      value: 0,
    }
  ];
  public loader:any = false;
  public qaLoader:any = false;
  public comments:any = false;
  public agentComments:any = false;
  public qaRating:any = false;
  public rating_val : any;
  public qa_feedback_note : any;
  public addCommentForm: FormGroup;
  public submitted: any = false;


  public many_orders_detail : any = {
    first_paid_order_date: "",
    first_unpaid_order_date: "",
    last_paid_order_date: "",
    last_unpaid_order_date: "",
    paid_orders_value: 0,
    total_paid_orders: 0,
    total_unpaid_orders: 0,
    unpaid_orders_value: 0 
  };

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: any = new Subject();

  public maxPriceLabel = { name: 'Any', value: 10000 };
  public searchParams: any = { emailId: '', orderStatus: null, agent_id: [], date_from: '', date_to: '', min_amount: 0, max_amount: this.maxPriceLabel.value, verified_sales: null };
  public fullRangeDate: any;
  public base64Pipe: any = new Base64Pipe;
  public oldWriterDD: any = [];

  public DOC_URL                  : any = AppSettings.DOC_URL
  public docs_revised_orders_path : any = AppSettings.docs_revised_orders_path
  public Rev_SubWork        : any = { document_note: '', attach: [], oldAttach: '', plag_report: [], oldPlag: '' };
  public Rev_InvalidRes     : any = '';
  public Rev_Index          : any = null;
  public Rev_ActionLoader   : any = false;
  public Rev_FileLoader     : any = false;
  public Rv_Attachment      : any = [];
  public Rv_plag            : any = [];
  public Rev_Note           : any = '';
  public Rev_Status         : any;

  options: Options = {
    floor: 0,
    ceil: this.maxPriceLabel.value,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return "" + value;
        case LabelType.High:
          if (this.maxPriceLabel.value == value)
            return this.maxPriceLabel.name;
          else
            return this.searchParams.max_amount;
        default:
          return "";
      }
    }
  };

  public WR_Attach_PondOptions = {
          allowMultiple: true,
          labelIdle: `<p class='pond-badge'>Drag & Drop or <span class="browse">browse</span> <span> Upload as .zip or .rar format in case of multiple files. </span></p>`,
          allowImagePreview: true,
          maxFileSize: '5MB',
          imagePreviewMaxFileSize: '5MB',
          // stylePanelLayout: 'compact circle',
          server: {
              url: AppSettings.API_ENDPOINT,
              timeout: 200000,
              process: {
                  url: './admin/upload-temp-files',
                  method: 'POST',
                  withCredentials: false,
                  timeout: 30000,
                  onload: (response) => {
                    // Hide File Upload Loader
                    this.Rev_FileLoader = false;

                    let parsedData = JSON.parse(response);
                    let decrptedImg = this.helperService.decrypted(parsedData.data);
                    let image = JSON.parse(decrptedImg);

                    // Add image to pro image array
                    this.Rv_Attachment.push(image.id);

                    return image.id;
                  },
                  onerror: (response) => {
                      return response.key;
                  },
                  ondata: (formData) => {
                      // Show File Upload Loader
                      this.Rev_FileLoader = true;

                      return formData;
                  }
              },
              revert: (uniqueFileId, load, error) => {
                  // Rmeove from array
                  this.Rv_Attachment.splice(this.Rv_Attachment.indexOf(uniqueFileId), 1);

                  // Clear Image
                  load();
              },
              restore : null,
              load    : null,
              fetch   : null
          }
      };

        public WR_Plag_PondOptions = {
          allowMultiple: true,
          labelIdle: `<p class='pond-badge'>Drag & Drop or <span class="browse">browse</span> <span> Upload as .zip or .rar format in case of multiple files. </span></p>`,
          allowImagePreview: true,
          maxFileSize: '5MB',
          imagePreviewMaxFileSize: '5MB',
          // stylePanelLayout: 'compact circle',
          server: {
              url: AppSettings.API_ENDPOINT,
              timeout: 200000,
              process: {
                  url: './admin/upload-temp-files',
                  method: 'POST',
                  withCredentials: false,
                  timeout: 30000,
                  onload: (response) => {
                    // Hide File Upload Loader
                    this.Rev_FileLoader = false;

                    let parsedData = JSON.parse(response);
                    // console.log("response.data******", response.data);
                    let decrptedImg = this.helperService.decrypted(parsedData.data);
                    let image = JSON.parse(decrptedImg);

                    // Add image to pro image array
                    this.Rv_plag.push(image.id);

                    return image.id;
                  },
                  onerror: (response) => {
                      return response.key;
                  },
                  ondata: (formData) => {
                      // Show File Upload Loader
                      this.Rev_FileLoader = true;

                      return formData;
                  }
              },
              revert: (uniqueFileId, load, error) => {
                  // Rmeove from array
                  this.Rv_plag.splice(this.Rv_plag.indexOf(uniqueFileId), 1);

                  // Clear Image
                  load();
              },
              restore : null,
              load    : null,
              fetch   : null
          }
      };

      pondFiles = []

  constructor(
    private helperService           : HelperService,
    private agentsService           : Agents,
    private authenticationService   : AuthenticationService,
    private formBuilder             : FormBuilder,
    private renderer                : Renderer2

  ) {

    this.activeUser = this.authenticationService.get_currentUserValue();


    // toggle price input
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.menuBtnClick) {
        this.showprice = 'none';
      }
      this.menuBtnClick = false;
    });

    // Get Agents
    this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
      if (agents) {
        this.agents = agents.agents;
        if (!this.agents.find(agent => agent.id === 'all')) {
          this.agents.unshift({ name: 'Select All', id: 'all' });
        }
       
        // if (!this.agents.find(agent => agent.id === 'auto')) {
        //   this.agents.unshift({ id: 'auto', name: 'Auto Sales', salesagent: 'auto' });
        // }

        this.select2Agents = [];
        let selectRegion = [{ label: 'Leads', val: '~' }, { label: 'Unpaid', val: 'unpaid_~' }, { label: 'CWHP', val: 'cwhp_~' }];
        for (let i = 0; i < selectRegion.length; i++) {
          for (let j = 0; j < this.agents.length; j++) {
            let agent = $.extend(true, {}, this.agents[j]);
            agent.region = selectRegion[i].label;
            agent.value = selectRegion[i].val + agent.id;
            this.select2Agents.push(agent);
          }
        }
        this.qa = agents.qa;
        this.writers = agents.writers;
      }
    });

    this.dtOptions = {
      paging: true,
      info: true,
      // ordering: false,
      pagingType: 'full_numbers',
      pageLength: 25,
      serverSide: true,
      processing: true,
      searching: false,
      'language': AppSettings.dataTableLang,
      "columnDefs": [
        { "orderable": false, "targets": 0  },
        { "orderable": true,  "targets": 1  },
        { "orderable": true,  "targets": 2  },
        { "orderable": false, "targets": 3  },
        { "orderable": false, "targets": 4  },
        { "orderable": true,  "targets": 5  },
        { "orderable": false, "targets": 6  },
        { "orderable": false, "targets": 7  },
        { "orderable": false, "targets": 8  },
        { "orderable": false, "targets": 9  },
        { "orderable": false, "targets": 10 },
        { "orderable": false, "targets": 11 },
        { "orderable": false, "targets": 12 },
        { "orderable": false, "targets": 13 }
      ],
      "order": [[1, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        // Show Loader
        this.loading = true;
        // console.log("dataTablesParameters", dataTablesParameters);

        let url = AppSettings.API_ENDPOINT + 'qa/order-management';;

        // // For Both SuperAdmin and QA
        // let url = AppSettings.API_ENDPOINT + 'admin/order-management';

        let dtParams = {
          lead           : this.searchParams.emailId,
          status         : this.searchParams.orderStatus,
          agent_id       : this.searchParams.agent_id,
          min_amount     : this.searchParams.min_amount,
          max_amount     : this.searchParams.max_amount,
          verified_sales : this.searchParams.verified_sales,
          date_from      : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
          date_to        : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false) : '',
          start          : dataTablesParameters.start,
          length         : dataTablesParameters.length,
          order          : dataTablesParameters.order,
          columns        : dataTablesParameters.columns,
        };

        // For Record Serial Numbers
        this.paginatePage = dataTablesParameters.start;

        // Empty Data
        this.leads = [];

        this.helperService.httpPostRequestsDecryp(url, dtParams)
          .then(resp => {
            this.leads        = JSON.parse(resp);
            this.leads_Copy   = $.extend(true, {}, this.leads);
            console.log("this.leads", this.leads);

            // Set Default page len
            this.dtOptions.pageLength = this.dtElement['dt'].page.len();

            // Hide Loader
            this.loading = false;

            callback({
              recordsTotal: this.leads.total,
              recordsFiltered: this.leads.total,
              // recordsFiltered: resp['recordsFiltered'],
              // recordsFiltered: 1000,
              data: []
            });

            // // $(".paginate_button .current").css("color", "white");
            // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
            $('div.dataTables_length select').addClass('dt-form-control');
            $('div.dataTables_filter input').addClass('dt-form-control');
          })
          .catch(error => {
            // Set loader false
            this.loading = false;

            // // Rerender DT in case of failure
            // this.rerender();

            console.log("error: ", error);
          });
      },
      columns: [
        { data: 'id' },
        { data: 'id' },
        { data: 'date' },
        { data: 'name' },
        { data: 'amount' },
        { data: 'delivery_date' },
        { data: 'writer_id' },
        { data: 'writer_delivery_date' },
        { data: 'agent' },
        { data: 'status' },
        { data: 'verified_sales' },
        { data: 'valid_sales' },
        { data: 'qaComments' },
        { data: 'comments' },
      ],
      // Use this attribute to enable the responsive extension
      responsive: false
    }

  }


  ngOnInit() {
      this.addCommentForm = this.formBuilder.group({
        qaFeedback: [null, Validators.required],
      });
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  selectAll() {
    if (this.searchParams.agent_id.includes('all')) {
      // If "Select All" is checked, select all agent IDs except 'all'
      this.searchParams.agent_id = this.agents
        .filter(agent => agent.id !== 'all')
        .map(agent => agent.id);
    } else if (this.searchParams.agent_id.length === 0) {
      // If no agent is selected, re-add "Select All"
      this.searchParams.agent_id = ['all'];
    }
    this.rerender()
  }

  splitFromTo() {
    console.log("this.fullRangeDate", this.fullRangeDate);

    if (this.fullRangeDate) {
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to = this.fullRangeDate[1];
    }
    this.rerender();
  }

  updateValidInvalid(lead, index) {
    // Show loader
    this.leads.data[index].updatingValid = true;

    let data = { oid: lead.id, status: lead.valid_sales };
    let url = AppSettings.API_ENDPOINT + "qa/mark-valid-invalid";

    this.helperService.httpPostRequests(url, data).then(resp => {
        if(typeof resp != "undefined") {
          if (resp.status == 'OK') {
              let self = this;
              this.leads.data[index].valUpdated = true;
              setTimeout(() => {
                  self.leads.data[index].valUpdated = false;
              }, 1500);
          } else {
              Swal.fire('', resp.message, 'error');
          }
        }

        // Hide loader
        this.leads.data[index].updatingValid = false;
    }).catch(err => {

        // Hide loader
        this.leads.data[index].updatingValid = false;
    });
  }

  setVerifiedStatusId(lead, index) {
    $("#markVerified"+ index).modal("show");
    $(".modal-backdrop").click(function() {
      $("#markVerified"+ index).modal("hide");
    });
  }

  setVerifiedStatus(index, lead) {
    // Show Loader
    this.leads.data[index].markingVerify = true;

    // Hide Modal
    $("#markVerified"+index).modal("hide");

    let url  = AppSettings.API_ENDPOINT + "shared/mark-verified";
    let data = { id: lead.id, status: lead.verified_sales ? 0 : 1 };

    this.helperService.httpPostRequests(url, data).then(resp => {
        if (typeof resp != "undefined" && resp.status == "OK") {
          // Update Verified
          this.leads.data[index].verified_sales = lead.verified_sales ? 0 : 1;

          let self = this;
          this.leads.data[index].verifyUpdated = true;
          setTimeout(() => {
            self.leads.data[index].verifyUpdated = true;
          }, 1500);
        }

        // Hide Loader
        this.leads.data[index].markingVerify = false;
    }).catch(err => {
        // Hide Loader
        this.leads.data[index].markingVerify = false;
    });
  }

  parseFloatCustom(value) {
    return parseFloat(value);
  }

  agentSearch(id, agentArr) {
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }
  }

  clearFilters() {
    this.searchParams = {
      emailId: '',
      disposition: null,
      agent_id: [],
      date_from: '',
      date_to: '',
      min_amount: 0,
      max_amount: this.maxPriceLabel.value
    };
    this.fullRangeDate = '';
    this.rerender();
  }

  checkClass(value) {
    if (value == 'yes') {

      this.checkedClass = true;
    }
    else {
      this.checkedClass = false;

    }
  }

  showComments(lead, index, type = "") {
    // this.loader = true;
    this.agentComments = [];
    this.qaComments    = [];
    this.loader = lead.id;

    let url = AppSettings.API_ENDPOINT + "shared/get-comments";
    let data = { o: lead.id, type: '' };
    this.helperService.httpPostRequests(url, data).then(resp => {
      if (typeof resp != "undefined") {
        this.comments = resp.data;

        for (let i = 0; i < this.comments.length; i++) {
          if (this.comments[i].type == "Closed-Agent-Comments") {
            this.agentComments.push(this.comments[i]);
          }
          else if (this.comments[i].type == "QA-Comments") {
            this.qaComments.push(this.comments[i]);
          }
        }

          if (type == "" && this.agentComments.length == 0 && this.qaComments.length == 0) {
            Swal.fire('No comments', "Agents and QA haven't added any comments yet.", 'info');
          } else {
            if (typeof $ != "undefined") {
              $("#comment_modal" + index).modal("show");
            }
          }


        // Hide loaders
        this.loader = '';

        $(".modal-backdrop").click(function() {
          $("#comment_modal" + index).modal("hide");
        });
      }

    });
  }

  pondHandleInit() {
    // console.log('FilePond has initialised', this.myPond);
  }

  pondHandleAddFile(event: any) {
    // console.log('A file was added', event);
  }

  pondHandleActivateFile(event: any) {
    // console.log('A file was activated', event)
  }

  showQAComments(lead, index) {
    // Show Loader
    this.leads.data[index].qaComLoader = true;

    // Reset Vars
    this.submitted = false;
    this.rating_val  = this.leads.data[index].rating;
    this.qa_feedback_note = '';

    let url = AppSettings.API_ENDPOINT + "shared/get-comments";
    let data = { o: lead.id, type: 'QA-Comments' };

    this.helperService.httpPostRequests(url, data).then(resp => {
        if (typeof resp != "undefined") {
          this.comments   = resp.data;
          this.qaComments = [];

          for (let i = 0; i < this.comments.length; i++) {
            if (this.comments[i].type == "QA-Comments") {
              this.qaComments.push(this.comments[i]);
            }
          }
        }

        // Show Modal
        $("#addQAFeedback" + index).modal("show");
        $(".modal-backdrop").click(function() {
          $("#addQAFeedback" + index).modal("hide");
        });

        // Hide Loader
        this.leads.data[index].qaComLoader = false;
    }).catch(err => {
        // Hide Loader
        this.leads.data[index].qaComLoader = false;
    });
  }

  setRating(rating) {
    this.rating_val = rating;
  }

  get f() { return this.addCommentForm.controls; }

  addQAFeedback(lead, index){
      // Set Submission True
      this.submitted = true;

      // Stop here if form is invalid
      if (this.addCommentForm.invalid) {
        return;
      }

      // Show Loader
      this.qaLoader = true;

      let url  = AppSettings.API_ENDPOINT + "shared/update-qa-rating-and-comments";
      let data = {
                    oid              : lead.id,
                    rating           : this.rating_val,
                    rating_comments  : this.qa_feedback_note
                  };

      this.helperService.httpPostRequests(url,data).then(resp => {

          if(typeof resp != "undefined" && resp.status == 'OK') {
              Swal.fire('', resp.message, 'success');

              // Update to new rating
              this.leads.data[index].rating = this.rating_val;
          } else {
              Swal.fire('', resp.message , 'error');
          }
          // Hide Modal
          $("#addQAFeedback" + index).modal("hide");
          $('.modal-backdrop').remove();
          this.qaLoader = false;
      }).catch(err => {
          // Hide Zip loader
          this.qaLoader = false;
      });
  }

  totalPaymentSearch(id, despoArr) {
    for (var i = 0; i < despoArr.length; i++) {
      if (despoArr[i].value === id) {
        return despoArr[i].name;
      }
    }
  }

  
  showManyOrder(lead, index, type = "") {
    // this.loader = true;
    this.agentComments = [];
    this.qaComments    = [];
    this.loader = lead.id;

    let url = AppSettings.API_ENDPOINT + "shared/get-orders-detail/"+lead.user_id;
    let data = { o: lead.id, type: '' };
    this.helperService.httpPostRequests(url, data).then(resp => {
      if (typeof resp != "undefined") {
        this.many_orders_detail = resp.data;
        // console.log('this.many_orders_detail',this.many_orders_detail);

        

          if (typeof $ != "undefined") {
            $("#many_order_modal" + index).modal("show");
          }
           

        // Hide loaders
        this.loader = '';

        $(".modal-backdrop").click(function() {
          $("#many_order_modal" + index).modal("hide");
        });
      }

    });
  }
}
